import React from 'react';
import {TextField} from '@mui/material';
import PropTypes from 'prop-types';
import {toLocalDateTime, toUTCDateTime} from "../utils/dateUtils";


export default function DateTimeField({label = '', name, value, onChange, error, helperText}) {

    const handleChange = (e) => {
        const localValue = e.target.value;
        const utcValue = toUTCDateTime(localValue);
        onChange({target: {name, value: utcValue}});
    };

    return (
        <TextField
            variant="standard"
            fullWidth
            label={label}
            name={name}
            type="datetime-local"
            slotProps={{
                    inputLabel: {shrink: true},
            }}
            value={toLocalDateTime(value)}
            onChange={handleChange}
            error={!!error}
            helperText={helperText}
        />
    );
}

DateTimeField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};
